import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";

export default class TestnameInput extends React.Component {
  state = {
    selectedOptions: []
  };

  fetchData = (search) =>
    fetchJson("/measurements.json", { search, ignore_internal: this.props.hideInternal }).then(
      (records) => records.map((m) => ({ label: m.name, value: m.id }))
    );

  fetchSelectedOptions = async () => {
    const { value } = this.props;
    if (value && value.length > 0) {
      const records = await fetchJson("/measurements.json", { ignore_internal: this.props.hideInternal });
      const options = records.map(m => ({ label: m.name, value: m.id }));
      const filtered = options.filter(o => value.includes(o.value));
      this.setState({ selectedOptions: filtered });
    } else {
      this.setState({ selectedOptions: [] });
    }
  };

  componentDidMount() {
    this.fetchSelectedOptions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.fetchSelectedOptions();
    }
  }

  customStyles = () => {
    const { width, defaultStyle } = this.props;
    if (defaultStyle) return {};
    return {
      control: (base, state) => ({
        ...base,
        width: width || 300,
      }),
    };
  };

  handleChange = (selected) => {
    const selections = Array.isArray(selected) ? selected : (selected ? [selected] : []);
    this.setState({ selectedOptions: selections });
    if (this.props.returnIds) {
      const ids = selections.map(o => o.value);
      const payload = this.props.multiple ? ids : (ids[0] || null);
      this.props.onChange && this.props.onChange(payload);
    } else {
      const payload = this.props.multiple ? selections : (selections[0] || null);
      this.props.onChange && this.props.onChange(payload);
    }
  };

  render() {
    const { multiple } = this.props;
    const { selectedOptions } = this.state;
    
    return (
      <AsyncSelect
        value={selectedOptions}
        placeholder={multiple ? I18n.t("select_testnames") : I18n.t("select_testname")}
        isMulti={multiple}
        autoload={true}
        styles={this.customStyles()}
        id="testname_id"
        loadOptions={this.fetchData}
        isClearable
        onChange={this.handleChange}
      />
    );
  }
}
